<template>
  <pt-save-sign class="pt-save-sign__page"></pt-save-sign>
</template>

<script>
import PtSaveSign from 'cps/appointment-application/pt-save-sign/withData'
export default {
  name: 'pt-save-sign__view',
  components: {
    'pt-save-sign': PtSaveSign
  }
}
</script>
